import React from 'react';
import './CheckboxInput.scss';
import PropTypes from 'prop-types';

export default function CheckboxInput(props) {
  const {
    children,
    register,
  } = props;

  return (
    <div className="checkbox-container">
      <input
        type="checkbox"
        {...register}
      />

      { children && (
        <span>
          { children }
        </span>
      )}
    </div>
  );
}

CheckboxInput.defaultProps = {
  children: undefined,
  register: {},
};

CheckboxInput.propTypes = {
  children: PropTypes.node,
  register: PropTypes.shape(),
};
